<template>
  <v-table
    url="/api/v1/coupon"
    :attributes="[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'slug',
        name: 'Code'
      },
      {
        attribute: 'start',
        name: 'Start',
        type: 'DateTimeCell'
      },
      {
        attribute: 'end',
        name: 'Ende',
        type: 'DateTimeCell'
      },
      {
        attribute: 'amount',
        name: 'Menge an Coins'
      },
      {
        attribute: 'active',
        name: 'Aktiv?',
        type: 'CheckMarkerCell'
      },
      {
        attribute: 'for_one',
        name: 'Einmal einlösbar?',
        type: 'CheckMarkerCell'
      },
      {
        attribute: 'redeem_count',
        name: 'Einlösungen',
        type: 'ModalCell',
        modal: 'RedeemedCouponCustomersModal',
        sortable: false
      },
      {
        type: 'CouponActionCell',
        name: 'Aktionen'
      }
    ]"
  ></v-table>
</template>

<script lang="babel">
export default {
  created () {
    this.$store.dispatch("coupon/read");
  }
}
</script>
